// NEW_FILE_JUSTIFIED: New route page under src/pages/control/ — no existing ControlDashboardPage
import { Navigate, useNavigate } from 'react-router-dom';
import { StatCard } from '@/components/dashboard/StatCard';
import { Button } from '@/components/ui/button';
import { useControlDashboardStats } from '@/hooks/useControlDashboardStats';
import { useSuperadminContext } from '@/hooks/useSuperadminContext';
import { Users, Building2, ClipboardList } from 'lucide-react';

export function ControlDashboardPage() {
  const navigate = useNavigate();
  const { isSuperadmin, isLoading } = useSuperadminContext();
  const stats = useControlDashboardStats();

  // Redirect non-superadmin users who navigate here directly
  if (!isLoading && !isSuperadmin) {
    return <Navigate to="/" replace />;
  }

  if (stats.isSuperadmin) {
    return (
      <div className="flex flex-col gap-6 p-6">
        <h1 className="text-2xl font-semibold text-foreground">Control Dashboard</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <StatCard label="Total Users" value={stats.totalUsers} subtitle="Registered accounts" />
          <StatCard
            label="Organisations"
            value={stats.totalOrgs}
            subtitle="Insurance organisations"
          />
          <StatCard label="Companies" value={stats.totalCompanies} subtitle="Across all orgs" />
          <StatCard
            label="Total Policies"
            value={stats.totalPolicies}
            subtitle={`${stats.activePolicies ?? 0} active`}
          />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Button
            variant="outline"
            className="h-auto py-4 flex flex-col items-center gap-2"
            onClick={() => navigate('/control/users')}
          >
            <Users className="w-5 h-5" />
            <span>Manage Users</span>
          </Button>
          <Button
            variant="outline"
            className="h-auto py-4 flex flex-col items-center gap-2"
            onClick={() => navigate('/control/organisations')}
          >
            <Building2 className="w-5 h-5" />
            <span>Manage Organisations</span>
          </Button>
          <Button
            variant="outline"
            className="h-auto py-4 flex flex-col items-center gap-2"
            onClick={() => navigate('/control/templates')}
          >
            <ClipboardList className="w-5 h-5" />
            <span>Policy Templates</span>
          </Button>
        </div>
      </div>
    );
  }

  return null;
}
